import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuthContext } from '../../auth/useAuthContext';
import { PATH_DASHBOARD } from '../../routes/paths';
// import { redirectToAppSubdomain, redirectToMainDomain } from '../../auth/utils';

export default function OAuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { session, isInitialized } = useAuthContext();

  useEffect(() => {
    console.log('🔄 [OAuthCallback] Processing OAuth callback');
    console.log('🔄 [OAuthCallback] Current URL:', window.location.href);
    console.log('🔄 [OAuthCallback] Hash:', window.location.hash);
    console.log('🔄 [OAuthCallback] Session:', !!session);
    console.log('🔄 [OAuthCallback] Initialized:', isInitialized);
    
    const handleCallback = async () => {
      // Wait for Supabase to process the OAuth tokens
      if (!isInitialized) {
        console.log('🔄 [OAuthCallback] Waiting for initialization...');
        return;
      }

      // Check if we have OAuth error
      const hashParams = new URLSearchParams(window.location.hash.substring(1));
      const error = hashParams.get('error');
      const errorDescription = hashParams.get('error_description');
      
      if (error) {
        console.error('❌ [OAuthCallback] OAuth error:', error, errorDescription);
        // redirectToMainDomain('/signin');
        navigate('/signin');
        return;
      }

      // If we have a session, redirect to intended destination
      if (session) {
        console.log('✅ [OAuthCallback] Session established, redirecting...');
        const from = location.state?.from || PATH_DASHBOARD.dashboard;
        // redirectToAppSubdomain(from);
        navigate(from);
      } else if (isInitialized && !window.location.hash) {
        // If initialized but no session and no hash, something went wrong
        console.log('❌ [OAuthCallback] No session after initialization');
        // redirectToMainDomain('/signin');
        navigate('/signin');
      }
    };

    handleCallback();
  }, [session, isInitialized, navigate, location]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      flexDirection="column"
      gap={2}
    >
      <CircularProgress />
      <Box>Processing authentication...</Box>
    </Box>
  );
}